import * as actions from '../actions/index' 
import _ from "lodash"
import { listMapper } from '../CBP_App/reducer/PGAReducer'
import { deletePGAItems } from '../CBP_App/api/deleteFormData'
import { savePGAItemField } from '../CBP_App/api/setFormData'

let initialState = {}

const dynamicPgaData = (state = initialState, action) => {
    let pgaData = _.cloneDeep(state)
    switch(action.type){
        case actions.INITIATE_DYNAMIC_PGA_DATA: {
            return action.payload
        }
        case actions.UPDATE_DYNAMIC_PGA_DATA: {
            const {isEngine} = action;
            if(!pgaData[action.formType]){
                for(let oneTopLevelKey of Object.keys(pgaData||{})){
                    for(let oneSecondLevelKey of Object.keys(pgaData[oneTopLevelKey]||{})){
                        if(oneSecondLevelKey.includes(action.pgaGuid)){
                            pgaData[oneTopLevelKey][oneSecondLevelKey][action.fieldName].value = action.value;
                            if(isEngine)
                              pgaData[oneTopLevelKey][oneSecondLevelKey][action.fieldName].changed = "true";
                        }   
                    }
                }
            } else if(Object.values(pgaData[action.formType])[0][action.fieldName]){
              Object.values(pgaData[action.formType])[0][action.fieldName].value = action.value;
              if(isEngine)
                Object.values(pgaData[action.formType])[0][action.fieldName].changed = "true";
            }   
            else{
                Object.values(pgaData[action.formType])[0][action.fieldName] = {
                    value: action.value
                }
                if(isEngine)
                  Object.values(pgaData[action.formType])[0][action.fieldName].changed = "true";
            }
            return pgaData
            
        }
        case actions.UPDATE_DYNAMIC_REPEATED_SUB_FIELD: {
            let list = _.cloneDeep(Object.values(pgaData[action.targetPGA])[0][action.list])
            let cardinality = action.containerCardinality;;
            if(!list[cardinality][action.index])return state;
            list[cardinality][action.index][action.field] = list[cardinality][action.index][action.field] || {};
            list[cardinality][action.index][action.field].value = action.payload
            if(action.isEngine)
              list[cardinality][action.index][action.field].changed = "true";
            Object.values(pgaData[action.targetPGA])[0][action.list] = list;
            return pgaData;
        }
        case actions.UPDATE_DYNAMIC_REPEATED_SUB_SUB_FIELD: {
            let list = _.cloneDeep(Object.values(pgaData[action.targetPGA])[0][action.list])
            let cardinality = action.containerCardinality;;
            let innerContainerCardinality = action.innerContainerCardinality;
            if(!list[cardinality][innerContainerCardinality][action.index])return state;
            list[cardinality][innerContainerCardinality][action.index][action.field] = list[cardinality][innerContainerCardinality][action.index][action.field] || {};
            list[cardinality][innerContainerCardinality][action.index][action.field].value = action.payload
            if(action.isEngine)
              list[cardinality][innerContainerCardinality][action.index][action.field].changed = "true";
            Object.values(pgaData[action.targetPGA])[0][action.list] = list;
            return pgaData;
        }
        case actions.UPDATE_DYNAMIC_REPEATED_FIELD: {
            if(!Object.values(pgaData[action.targetPGA])[0][action.list]) return state
            let list = _.cloneDeep(Object.values(pgaData[action.targetPGA])[0][action.list])
            list[action.index][action.field].value = action.payload
            if(action.isEngine)
              list[action.index][action.field].changed = "true";
            Object.values(pgaData[action.targetPGA])[0][action.list] = list;
            return pgaData
        }
        case actions.UPDATE_DYNAMIC_LACEY_FIELD: {
            Object.values(pgaData["LACEY"])[0][action.field].value = action.payload;
            if(action.isEngine)
              Object.values(pgaData["LACEY"])[0][action.field].changed = "true";
            return pgaData;
        }
        case actions.UPDATE_DYNAMIC_PGA_ITEM_FIELD: {
            Object.values(pgaData["LACEY"])[0].PGAItemList[action.index][action.field].value = action.payload;
            if(action.isEngine)
              Object.values(pgaData["LACEY"])[0].PGAItemList[action.index][action.field].changed = "true";
            return pgaData;
        }
        case actions.ADD_REPEATED_DYNAMIC_PGA_ITEM: {
            if(!Object.values(pgaData[action.targetPGA])[0][action.list]) return state;
            let list = _.cloneDeep(Object.values(pgaData[action.targetPGA])[0][action.list])
            let itemsToBeAdded = listMapper[action.list](list.length + 1);
            if(action.isEngine){
              Object.values(itemsToBeAdded).forEach(item => {
                item.changed = "true";
              })
            }
            list.push(itemsToBeAdded);
            Object.values(pgaData[action.targetPGA])[0][action.list] = list;
            return pgaData;
        }
        case actions.REMOVE_REPEATED_GROUP: {
            if(!Object.values(pgaData[action.targetPGA])[0][action.list]) return state;
            let list = _.cloneDeep(Object.values(pgaData[action.targetPGA])[0][action.list])
            list.splice(action.index, 1);
            Object.values(pgaData[action.targetPGA])[0][action.list] = list;
            return pgaData;
        }
        case actions.REPLACE_ALL_REPEATED_ITEM_DYNAMIC: {
            if(!Object.values(pgaData[action.targetPGA])[0][action.list]) return state;
            // let list = _.cloneDeep(Object.values(pgaData[action.targetPGA])[0][action.list])
            // list.splice(action.index, 1);
            if(action.isEngine){
              action.newList.forEach((item, index) => {
                Object.values(item).forEach(item => {
                  item.changed = "true";
                })
              })
            }
            
            Object.values(pgaData[action.targetPGA])[0][action.list] = action.newList;
            return pgaData;
        }
        case actions.ADD_REPEATED_SUB_FIELD_DYNAMIC: {
            function getAllexistingindexes(boxforcurrentcardinality){
            let seen = [];
            for(var iii = 0; iii < boxforcurrentcardinality.length;iii++){
                if(boxforcurrentcardinality[iii]){
                let firstkey =_.find(boxforcurrentcardinality[iii],a=>a.key).key;
                seen[parseInt(firstkey.split(".")[2])-1]=true;
                }
            }
            return seen;
            }
            let cardinality = action.containerCardinality;
            let listname = action.list;
            let newindex = 0;
            let existingList = _.cloneDeep(Object.values(pgaData[action.targetPGA])[0][action.list])
            if(existingList  && existingList[cardinality]){
            let seen = getAllexistingindexes(existingList[cardinality]);
            for(;newindex<seen.length;newindex++){
                if(!seen[newindex])break;
            }
            }
            let itemsToSave = []
            let newItems = (existingList && existingList[cardinality])?existingList[cardinality].slice():[];
            if(action.initialValues_th.length){
            for(let oneItemToAdd of action.initialValues_th){
                let items = listMapper[listname](newindex)
                for(let itemkey of Object.keys(items)){
                items[itemkey].key = items[itemkey].key.split(".")[0]+"."+(cardinality+1)+"."+(newindex+1);
                
                }
    
                for (let itemKey in items) {
                    if(oneItemToAdd[itemKey]){
                    items[itemKey].value = oneItemToAdd[itemKey].value.value;
                    if(action.isEngine)
                        items[itemKey].changed = "true";
                }
                }
                for (let itemKey in items) {
                itemsToSave.push(items[itemKey])
                }
                newItems.push(items)
                newindex++;
            }
            
            } else {
            let items = listMapper[listname](newindex)
            for(let itemkey of Object.keys(items)){
                items[itemkey].key = items[itemkey].key.split(".")[0]+"."+(cardinality+1)+"."+(newindex+1);
                
            }

            for (let itemKey in items) {
                if(action.initialValues_th[itemKey]){
                    items[itemKey].value = action.initialValues_th[itemKey].value.value;
                    if(action.isEngine)
                        items[itemKey].changed = "true";
                }
            }
            for (let itemKey in items) {
                itemsToSave.push(items[itemKey])
            }
            newItems.push(items)
            }
            let listToSave = JSON.parse(JSON.stringify(existingList || []));
            listToSave[cardinality] = newItems;
            Object.values(pgaData[action.targetPGA])[0][listname] = listToSave;
            // Object.assign({}, Object.values(pgaData[action.targetPGA])[0], {[listname] : listToSave})
            return pgaData;
        }
        case actions.REMOVE_SUB_FIELD_GROUPS_DYNAMIC: {
        let cardinality = action.containerCardinality;
        let listname = action.list;
        let existingList = _.cloneDeep(Object.values(pgaData[action.targetPGA])[0][action.list])
        if(!existingList)return state;
        let mainlist = existingList;
        if(!mainlist)return state;
        let deletedGroup = null;
        let removeByCardinality = (cardinalityXX) =>{
          deletedGroup = mainlist[cardinalityXX];
          mainlist[cardinalityXX] = null;
          if (deletedGroup) {
            let everyThingToDelete = deletedGroup.map(a => {
              let newArray = [];
              for (let oneKey of Object.keys(a)) {
                newArray.push(a[oneKey])
              }
              return newArray
            }).reduce((a, b) => {
              return a.concat(b)
            }, []);
          }
          
        }
        if(cardinality == 'all'){
          for(let iii=0;iii<mainlist.length;iii++ ){
            removeByCardinality(iii)
          }
        } if(action.payload == 'all'){
          removeByCardinality(cardinality)
        } else {
          deletedGroup = mainlist[cardinality][action.payload];
          mainlist[cardinality][action.payload]=null;
        }
        if(!deletedGroup)return state;
      let idxxxx = 1;
      (mainlist[cardinality]||[]).forEach(item =>{//relabel
        if(item){
          for(let onevarrr of Object.keys(item)){ 
            let thekey = item[onevarrr].key;
            if(!thekey)continue;//We hit a subgroup or something, ignore it
            item[onevarrr].key = [thekey.split('.')[0],thekey.split('.')[1],idxxxx].join(".");
          }
          idxxxx++;
        }
      })
  
      let listToSave=JSON.parse(JSON.stringify(mainlist));
        
        for(let listtoclean of listToSave){
          if(!listtoclean)continue;
          listToSave[listToSave.indexOf(listtoclean)] = listtoclean.filter?listtoclean.filter((a)=>a):listtoclean;//strip nulls
        }
        Object.values(pgaData[action.targetPGA])[0][listname] = listToSave;
        // return Object.assign({}, state, { [listname]: listToSave })
        return pgaData;

      }
        default:
            return state
    }
}

export default dynamicPgaData;